const isPathOrChild = (pathname, routePath) => {
	return pathname === routePath || (pathname && pathname.indexOf(routePath + '/') === 0);
};

export const isDashboardPath = pathname => isPathOrChild(pathname, '/dashboard');
export const isHeartbeatPath = pathname => isPathOrChild(pathname, '/heartbeat');
export const isUsersPath = pathname => isPathOrChild(pathname, '/users');
export const isStatisticsReportPath = pathname => isPathOrChild(pathname, '/statistics-report');
export const isUserMessageLogsPath = pathname => isPathOrChild(pathname, '/user-message-logs');

const productFilterPaths = [
	'/dashboard',
	'/procedure-reports',
	'/heartbeat',
	'/devices',
	'/users',
	'/user-message-logs',
	'/error-messages',
	'/statistics-report',
	'/downloads',
	'/top-performers'
];

export const shouldShowProductDropDown = pathname => {
	return productFilterPaths.some(routePath => isPathOrChild(pathname, routePath));
};

export const shouldShowMarketDropDown = (role, pathname) => {
	return parseInt(role) === 2 && isDashboardPath(pathname);
};
